// Cloudflare Turnstile appin lomakkeille (yhteydenotto, laskutilaus). Sama widget kuin tendera.fi:llä;
// hostname app.tendera.bid on sallittu widgetissä. Sivuston rajapinta tarkistaa tokenin (siteverify).
export const CONTACT_API = import.meta.env.VITE_CONTACT_API_URL || 'https://tendera.fi/api/contact';
export const TURNSTILE_SITEKEY = import.meta.env.VITE_TURNSTILE_SITEKEY || '0x4AAAAAAEtuzBx4COGwXYOp';
const TURNSTILE_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

export const loadTurnstile = () => new Promise((resolve, reject) => {
    if (window.turnstile) return resolve(window.turnstile);
    let s = document.querySelector(`script[src="${TURNSTILE_SRC}"]`);
    if (!s) { s = document.createElement('script'); s.src = TURNSTILE_SRC; s.async = true; document.head.appendChild(s); }
    s.addEventListener('load', () => resolve(window.turnstile));
    s.addEventListener('error', () => reject(new Error('turnstile')));
});

// Lähetys tendera.fi:n lomakerajapintaan. text/plain = CORS "simple request" (ei preflightia; Pages vastaa
// OPTIONS-pyyntöihin itse 405:llä ennen funktiota). Heittää virheen, jos vastaus ei ole ok.
export const postContact = async (payload) => {
    const res = await fetch(CONTACT_API, { method: 'POST', headers: { 'content-type': 'text/plain' }, body: JSON.stringify(payload) });
    const json = await res.json().catch(() => ({}));
    if (!res.ok || !json.ok) throw new Error(json.error || 'fail');
    return json;
};
